import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CancelButton = ({ title, className, ...props }) => {
    return (
        <button
            type="button"
            className={`btn btn-danger d-flex align-items-center ${className || ''}`}
            {...props}
        >
            <FontAwesomeIcon icon={faCircleXmark} className='me-1' />
            {title || 'Cancel'}
        </button>
    )
}

export default CancelButton